import { render, staticRenderFns } from "./SuggestionPortability.vue?vue&type=template&id=2245a69d&scoped=true&"
import script from "./SuggestionPortability.vue?vue&type=script&lang=ts&"
export * from "./SuggestionPortability.vue?vue&type=script&lang=ts&"
import style0 from "./SuggestionPortability.vue?vue&type=style&index=0&id=2245a69d&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2245a69d",
  null
  
)

export default component.exports